/*
 * @Author: chengfei
 * @Date: 2022-11-25 18:12:29
 * @LastEditTime: 2024-01-26 09:47:32
 * @LastEditors: yeyimei
 * @Description:
 * @FilePath: \cardlan-h5-qrcode\src\utils\mall.js
 */
import request from "./method-type.js"

// 获取首页数据(已弃用)
export const getHomeData = (data) => {
  return request.post("hm/shop/home", data)
}

//获取banner单独接口
export const getBannerListApi = (data) => {
  return request.post("hm/shop/banner/list", data)
}

// 获取推荐商品
export const getRecommendProduct = (data) => {
  return request.post("hm/shop/put/productList", data)
}

// 获取商品分页
export const getGoodsPage = (data) => {
  return request.post("hm/shop/spu/page", data)
}

// 获取获取商品详情
export const getGoodDetail = (data) => {
  return request.post(`hm/shop/spu/detail`, data)
}

//获取收货地址列表
export const getGoodsAdress = () => {
  return request.post("hm/shop/address/list")
}

// 保存收货地址
export const saveGoodsAddress = (data) => {
  return request.post("hm/shop/address/save", data)
}

// 删除收货地址
export const deleteGoodsAddress = (id) => {
  return request.delete(`hm/shop/address/delete/${id}`)
}

// 同意个人隐私和规则协议
export const agreeRule = () => {
  return request.post("hm/shop/user/agreePolicyRule")
}

// 提交订单
export const commitOrder = (data) => {
  return request.post("hm/shop/commitOrder", data)
}

// 获取用户订单分页
export const getGoodsOrder = (data) => {
  return request.post("hm/shop/order/page", data)
}

// 获取用户订单详情
export const getGoodOrderDetail = (id) => {
  return request.get(`hm/shop/order/detail/${id}`)
}

//商城售后申请
export const serviceAppilApi = (data) => {
  return request.post(`hm/shop/service/apply`, data)
}

//获取售后详情
export const getServiceDetailApi = (orderNo) => {
  return request.get(`hm/shop/service/detail/${orderNo}`)
}

//售后快递信息提交
export const serviceTrackCommitApi = (data) => {
  return request.post(`hm/shop/service/track/commit`, data)
}

//获取售后费用
export const getServiceFeeApi = (orderNo) => {
  return request.get(`hm/shop/service/fee/${orderNo}`)
}

//获取快递列表
export const getExpressListApi = () => {
  return request.get(`hm/shop/express/list`)
}

//获取退款类型
export const getRefundTypeListApi = () => {
  return request.get(`hm/shop/service/refundTypeList`)
}

//取消订单
export const cancelOrderApi = (orderNo) => {
  return request.put(`hm/shop/order/cancel/${orderNo}`)
}

//删除订单
export const delOrderApi = (orderNo) => {
  return request.delete(`hm/shop/order/delete/${orderNo}`)
}

//商城退款指引
export const getRefundApi = () => {
  return request.get(`hm/shop/explain/refund`)
}

//商城隐私说明
export const getPrivacyApi = () => {
  return request.get(`hm/shop/explain/privacy`)
}

//商城服务政策
export const getRulesApi = () => {
  return request.get(`hm/shop/explain/rules`)
}

//用户订单确认
export const getOrderConfirmApi = (orderNo) => {
  return request.put(`hm/shop/order/confirm/${orderNo}`)
}

//商城保障说明
export const getEnsureApi = () => {
  return request.get(`hm/shop/explain/ensure`)
}

//用户配置信息 是否同意服务政策和隐私
export const getUserConfigApi = (data) => {
  return request.post(`hm/shop/user/config`, data)
}

//待付款订单总数
export const getOrderPendingCountApi = () => {
  return request.get(`hm/shop/order/pendingCount`)
}

//商城分类列表
export const getColumnListApi = (data) => {
  return request.post(`hm/shop/column/list`, data)
}

//获取栏目信息--土特产
export const getColumnDetailApi = (columnCode) => {
  return request.get(`hm/shop/column/detail/${columnCode}`)
}

//会员开通价格
export const getOpenMemberPrice = (data) => {
  return request.get(`hm/vip/rank/list`, data)
}

//会员权益说明
export const getEquityStatement = (vipCode) => {
  return request.get(`hm/vip/explain/rank/get/${vipCode}`)
}

//会员协议
export const getMembershipAgreement = () => {
  return request.get(`hm/vip/explain/agreement`)
}

//会员权益列表
export const getMembershipBenefits = (vipCode) => {
  return request.get(`hm/vip/equity/list/${vipCode}`)
}

//会员开通
export const openMembershipHandler = (data) => {
  return request.post(`hm/vip/commitOrder`, data)
}

//高级会员 和 超级会员 积分(列表、类型)
export const getMemberVoucherHandler = (data) => {
  return request.post(`hm/coupon/vip/list`, data)
}

//高级会员 和 超级会员 领积分
export const collectingVouchers = (data) => {
  return request.post(`hm/coupon/vip/get`, data)
}

// 积分指定商品
export const vouchersDesignatedGoods = (data) => {
  return request.post(`hm/coupon/product/page`, data)
}

//获取当前用户会员开通记录
export const getUserRecordApi = () => {
  return request.get(`hm/vip/user/record`)
}

//会员商品类型
export const getVipProductTypeApi = (data) => {
  return request.post(`hm/vip/product/type`, data)
}

//获取会员等级列表
export const getVipRankListApi = (data) => {
  return request.post(`hm/vip/rank/list`, data)
}

//获取会员权益商品信息(一只鸡活动)
export const getVipProductInfoApi = (data) => {
  return request.post(`hm/vip/product/get`, data)
}

//获取会员专享活动配置
export const getVipConfigInfoApi = (vipCode) => {
  return request.get(`hm/vip/act/config/${vipCode}`)
}

//获取会员权活动状态
export const getVipStatusApi = () => {
  return request.get(`hm/vip/act/status/get`)
}

//高德周边搜索 用户新增收货地址页面
export const getlbsRoundPageApi = (data) => {
  return request.post(`hm/lbs/round/page`, data)
}

//获取商城门店分页
export const getShopStorePage = (data) => {
  return request.post(`hm/shop/store/page`, data)
}

//获取会员权益商品列表
export const getVipProductListApi = () => {
  return request.get(`hm/vip/product/list`)
}

//根据会员编码获取会员权益商品列表
export const getUnVipProductListApi = (vipcode) => {
  return request.get(`hm/vip/product/list/${vipcode}`)
}

//获取商品订单状态、核销状态
export const getConsumeInfoApi = (orderNo) => {
  return request.get(`/hm/shop/order/status/${orderNo}`)
}

//商城公告分页
export const getNoticePageApi = (data) => {
  return request.post(`hm/shop/notice/page`, data)
}

/**
 * @description 名片预览----预览名片
 *
 * */
export const previewBusinessCard = (data) => {
  return request.post(`hm/share/poster/preview`, data)
}

/**
 * @description 预览名片 详情
 *
 * */
export const getUserBusinessCard = (data) => {
  return request.post(`hm/share/poster/getUserBusinessCard`, data)
}
